/* src/components/EditorUI.module.css */

.container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 10;
  font-family: Arial, sans-serif;
}

/* Barra superior */
.topBar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 50px;
  background: rgba(30, 30, 40, 0.9);
  display: flex;
  align-items: center;
  padding: 0 16px;
  gap: 12px;
  pointer-events: auto;
  border-bottom: 1px solid #444;
}

.brandTitle {
  color: white;
  font-weight: bold;
  font-size: 18px;
}

.btn {
  padding: 8px 12px;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: opacity 0.2s;
}

.btn:hover {
  opacity: 0.9;
}

.btnPlay {
  composes: btn;
  padding: 8px 16px;
  font-weight: bold;
  background: #4caf50;
}

.btnPlayActive {
  composes: btn;
  padding: 8px 16px;
  font-weight: bold;
  background: #ff5722;
}

.btnSave {
  composes: btn;
  background: #2196f3;
}

.btnLoad {
  composes: btn;
  background: #607d8b;
}

.btnExport {
  composes: btn;
  background: #9c27b0;
}

/* Panel lateral izquierdo */
.leftPanel {
  position: absolute;
  top: 60px;
  left: 10px;
  width: 260px;
  max-height: calc(100% - 120px);
  background: rgba(30, 30, 40, 0.85);
  border-radius: 8px;
  padding: 12px;
  pointer-events: auto;
  overflow-y: auto;
  color: white;
}

.panelTitle {
  margin: 0 0 8px 0;
  font-size: 16px;
}

.panelTitleSpacing {
  margin: 16px 0 8px 0;
  font-size: 16px;
}

.emptyText {
  color: #aaa;
  font-size: 13px;
  margin: 0;
}

.itemList {
  list-style: none;
  padding: 0;
  margin: 0;
}

.buildingItem {
  padding: 8px;
  margin-bottom: 4px;
  background: #3a3a4a;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: background-color 0.15s;
}

.buildingItem:hover {
  background: #454558;
}

.buildingItemSelected {
  composes: buildingItem;
  background: #4caf50;
}

.buildingItemSelected:hover {
  background: #43a047;
}

.buildingHeightBadge {
  font-size: 11px;
  color: #ccc;
}

.roadItem {
  padding: 6px;
  background: #3a3a4a;
  margin-bottom: 4px;
  border-radius: 4px;
  font-size: 12px;
}

.moreItemsText {
  font-size: 11px;
  color: #aaa;
  margin-top: 4px;
}

/* Panel lateral derecho */
.rightPanel {
  position: absolute;
  top: 60px;
  right: 10px;
  width: 280px;
  max-height: calc(100% - 120px);
  background: rgba(30, 30, 40, 0.85);
  border-radius: 8px;
  padding: 12px;
  pointer-events: auto;
  color: white;
  overflow-y: auto;
}

.formGroup {
  margin-bottom: 12px;
}

.fieldLabel {
  display: block;
  font-size: 12px;
  color: #ccc;
  margin-bottom: 4px;
}

.textInput {
  width: 100%;
  padding: 6px;
  border-radius: 4px;
  border: 1px solid #555;
  background: #2a2a3a;
  color: white;
  font-size: 13px;
  box-sizing: border-box;
}

.colorInput {
  width: 100%;
  padding: 2px;
  border-radius: 4px;
  border: 1px solid #555;
  background: #2a2a3a;
  cursor: pointer;
  box-sizing: border-box;
  height: 32px;
}

.btnDelete {
  width: 100%;
  padding: 8px;
  background: #f44336;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 8px;
  font-size: 13px;
}

.btnDelete:hover {
  background: #d32f2f;
}

/* Barra inferior */
.bottomBar {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(30, 30, 40, 0.85);
  border-radius: 20px;
  padding: 8px 16px;
  pointer-events: auto;
  display: flex;
  gap: 8px;
  color: white;
  font-size: 13px;
}

/* Modales */
.modalBackdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: auto;
  z-index: 100;
}

.modalCard {
  background: white;
  padding: 24px;
  border-radius: 8px;
  min-width: 300px;
  max-width: 400px;
  color: black;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
}

.modalTitle {
  margin: 0 0 12px 0;
  font-size: 18px;
}

.modalDescription {
  margin: 0 0 16px 0;
  font-size: 14px;
  color: #555;
}

.modalInput {
  width: 100%;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #555;
  margin-bottom: 12px;
  font-size: 14px;
  box-sizing: border-box;
}

.modalActions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 12px;
}

.savedProjectItem {
  padding: 10px;
  background: #3a3a4a;
  color: white;
  margin-bottom: 6px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.savedProjectItem:hover {
  background: #4a4a5a;
}
